import { payment, paymentStripeClientSecret, paymentStripeIntention, paymentStripeSetupIntent } from "../../routes/api/paths";
import { handleResponse, requestOptions } from "../HandlerService";

export const PaymentStripeClient = async (data) => {
  const {token} = data
  const options = requestOptions('GET', {}, token);
  return fetch(paymentStripeClientSecret, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const PaymentStripeIntentionService = async (data) => {
  const {token, recharge_id} = data
  const options = requestOptions('POST', {recharge_id}, token);
  return fetch(paymentStripeIntention, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

// For mobile checkout - create payment intent by recharge ID
export const PaymentStripeIntentService = async (data) => {
  const { token, id } = data;
  const options = requestOptions('POST', { recharge_id: id }, token);
  return fetch(paymentStripeIntention, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const PaymentStripeSetupIntentService = async (data) => {
  const { token } = data;
  const options = requestOptions('POST', {}, token);
  return fetch(paymentStripeSetupIntent, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const PaymentIntent = async (data) => {
  if (!data?.token) return;
  const options = requestOptions('POST', data, data.token);
  return fetch(payment, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}